import * as React from 'react';
import { observer } from 'mobx-react';
import PersonaControl from './PersonaControl';
import { Callout, DirectionalHint } from 'office-ui-fabric-react/lib/Callout';
import { PersonaSize } from 'office-ui-fabric-react/lib/Persona';

let styles = require('./PersonaCard.scss');

export interface PersonaCardProps {
    emailAddress: string;
    name: string;
    targetElement: HTMLElement;
    onDismiss: (ev?: any) => void;
}

@observer
export default class PersonaCard extends React.Component<PersonaCardProps, {}> {
    private onMouseLeave = (ev?: React.MouseEvent<EventTarget>) => {
        this.props.onDismiss(ev);
    };

    render() {
        let { emailAddress, name, targetElement, onDismiss } = this.props;

        if (!targetElement) {
            return null;
        }

        return (
            <Callout
                target={targetElement}
                directionalHint={DirectionalHint.bottomLeftEdge}
                isBeakVisible={false}
                onDismiss={onDismiss}>
                <div onMouseLeave={this.onMouseLeave} className={styles.container}>
                    <PersonaControl
                        name={name}
                        emailAddress={emailAddress}
                        size={PersonaSize.large}
                        showPersonaDetails={true}
                        secondaryText={emailAddress}
                    />
                </div>
            </Callout>
        );
    }
}
